var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import PersonHighSchoolDomainService from "../Domain/PersonHighSchool/PersonHighSchool.service";
export default class PersonHighSchoolService {
    static search(search = {}, options = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield FetchService.getPagedResponse("/aviso/personHighSchool/search", {
                personIds: search.personIds,
                minEndDate: search.minEndDate,
                maxEndDate: search.maxEndDate,
                createdDateFrom: search.createdDateFrom,
                createdDateTo: search.createdDateTo,
                modifiedDateFrom: search.modifiedDateFrom,
                modifiedDateTo: search.modifiedDateTo,
                maxStartDate: search.maxStartDate,
                minStartDate: search.minStartDate,
                order: options.order,
                sort: options.sort,
                max: options.max,
                offset: options.offset,
            });
            return Object.assign(Object.assign({}, response), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: (_a = response.data) === null || _a === void 0 ? void 0 : _a.map(PersonHighSchoolDomainService.fromJSON) });
        });
    }
    /**
     * Returns a promise of an array of PersonHighSchools
     */
    static getHighSchools(personId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getPagedResponse("/aviso/personHighSchool/search", {
                personIds: [personId],
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            }).then((resp) => { var _a; return (_a = resp.data) === null || _a === void 0 ? void 0 : _a.map(PersonHighSchoolDomainService.fromJSON); });
        });
    }
}
